import type { TPreApprovalResultItem } from './types';

// создание Map productId -> TPreApprovalResultItem для быстрого доступа к данным оффера по его id
export const getPreApprovalResultMap = (items: TPreApprovalResultItem[]) => {
  return new Map(items.map((item) => [item.productId, item]));
};
